"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processStyleNode = void 0;
const react_1 = __importDefault(require("react"));
const generatePropsFromAttributes_1 = require("../utils/generatePropsFromAttributes");
const domhandler_1 = require("domhandler");
const domhandler_2 = require("domhandler");
function processStyleNode(node, index) {
    if (!(0, domhandler_2.isTag)(node)) {
        return null;
    }
    let styles;
    if (node.children.length > 0) {
        const subNode = node.children[0];
        if ((0, domhandler_1.isText)(subNode)) {
            styles = subNode.data;
        }
    }
    const props = (0, generatePropsFromAttributes_1.generatePropsFromAttributes)(node.attribs, index);
    return react_1.default.createElement('style', props, styles);
}
exports.processStyleNode = processStyleNode;
